export default "__VITE_ASSET__fe624743__"